const name = 'Scale';
const properties = {
    groups: ['animation'],
    schema: {
        duration: {
            type: 'number',
            min: 0,
            default: 0,
        },
        delay: {
            type: 'number',
            min: 0,
            default: 0,
        },
        from: {
            type: 'object',
            properties: {
                scale: {
                    type: 'number',
                    min: 0,
                },
                scaleX: {
                    type: 'number',
                    min: 0,
                },
                scaleY: {
                    type: 'number',
                    min: 0,
                },
            },
        },
        to: {
            type: 'object',
            properties: {
                scale: {
                    type: 'number',
                    min: 0,
                },
                scaleX: {
                    type: 'number',
                    min: 0,
                },
                scaleY: {
                    type: 'number',
                    min: 0,
                },
            },
        },
    },
};
/**
 * Scale animation object
 */
function animate(kit, elements, duration, delay, { from = {}, to = {}, ease = 'Sine.easeIn', ...params } = {}) {
    const sequence = kit.sequence(params);
    sequence.add(kit.animate('BaseScale', elements, duration, delay, {
        from,
        to,
        ease,
    }));
    return sequence.get();
}
export { name, properties, animate };
//# sourceMappingURL=scale.js.map